// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__OCB3-","messages":"Chat_messages__5rqCE","dateDivider":"Chat_dateDivider__WOIYP"};